import { Injectable, computed, inject } from '@angular/core';
import { IDisclosureModel } from '@partners/api';
import { DisclosureStore, SimulatorStore } from '@partners/state';

@Injectable({
  providedIn: 'root'
})
export class DisclosureFacade {
  private _simulatorStore = inject(SimulatorStore);
  private _disclosureStore = inject(DisclosureStore);

  disclosureModel$$ = computed<IDisclosureModel>(() => {
    const simulatorModel = this._simulatorStore.model$$();
    const loanProfile = this._simulatorStore.loanProfile$$();
    const loanProfileOption = this._simulatorStore.currentOption$$();
    const { loanAmount, numOfPayments } = simulatorModel;

    const disclosureModel: IDisclosureModel = {
      reqProfileCode: loanProfile.loanProfileCode,
      reqAmount: loanAmount,
      reqPaymentsNum: numOfPayments,
      reqInterest: loanProfileOption.interest,
      interestType: loanProfile.interestType,
      gapRate: loanProfileOption.gapRate
    };

    return disclosureModel;
  });

  loanProfile$$ = this._simulatorStore.loanProfile$$;
  isVariableInterest$$ = this._simulatorStore.isVariableInterest$$;

  constructor() {}

  /**
   * @description
   * a bridge method to allow sibling domains (loan simulator & loan disclosure) cross-access
   * to each other's model & data. before loading disclosure domain, we need to create & init
   * its model from the simulator data
   */
  createDisclosureModel() {
    const model = this.disclosureModel$$();
    this._disclosureStore.dispatchUpdateModel(model);
  }
}
